import {
  getStatus,
  getIconType,
  getImportance,
  getSolvability,
} from '../../constants/seoMappings';

/**
 * Generates message for email privacy section
 * Note: When emails are found, the count should be rendered with <strong> tags in JSX
 * @param {Array} data - The email addresses array
 * @returns {string} - Message for the section
 */
const generateMessage = (data) => {
  const emailCount = data?.length || 0;

  if (emailCount === 0) {
    return 'Good, no email address has been found in plain text.';
  }

  // Return null when emails found - component will render with bold count
  return null;
};

/**
 * Transforms the email_security criteria from WooRank API response
 * @param {Object} emailSecurityCriteria - The email_security criteria object from the API
 * @returns {Object} - Transformed email privacy data for React components
 */
export const transformEmailPrivacy = (emailSecurityCriteria) => {
  // Handle missing criteria - use 'neutral' status (maps to 'info' icon)
  if (!emailSecurityCriteria) {
    return {
      status: getStatus('neutral'),
      iconType: getIconType('neutral'),
      importance: { level: 0, text: '' },
      solvability: { level: 0, text: '' },
      isEmpty: true,
      message: 'Good, no email address has been found in plain text.',
      data: null,
    };
  }

  const data = emailSecurityCriteria?.data || [];
  const wooRankStatus = emailSecurityCriteria?.status || 'neutral';
  const importance = emailSecurityCriteria?.importance || 0;
  const solvability = emailSecurityCriteria?.solvability || 0;

  const emailCount = data?.length || 0;
  const isEmpty = emailCount === 0;

  return {
    status: getStatus(wooRankStatus),
    iconType: getIconType(wooRankStatus),
    importance: getImportance(importance),
    solvability: getSolvability(solvability),
    isEmpty,
    message: generateMessage(data),
    data: {
      emailCount,
    },
  };
};

export default transformEmailPrivacy;

